/**
 * API Utility
 * 
 * Centralized API configuration for backend communication
 * Handles JWT token in Authorization header
 */

import axios from 'axios';

// Backend API base URL
// For Create React App, use process.env.REACT_APP_API_URL
// For Vite, use import.meta.env.VITE_API_URL
const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

// Create axios instance
export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

// Request interceptor - Add JWT token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Token expired or invalid - clear and redirect
      localStorage.removeItem('accessToken');
      localStorage.removeItem('user');
      localStorage.removeItem('subscription');
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('isSubscribed');
      window.location.href = '/signin';
    }
    return Promise.reject(error);
  }
);

export default api;
